import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { boolean, nullable, string } from "../../../types/_types";

import { OrganizationRef } from "../../organizations/types/OrganizationRef";

export const Contractor = FirestoreDocument.extend({
	name: string(3),
	allowExternalUpload: boolean(false),
	password: nullable(string(4)),
	publisher: OrganizationRef,
}).merge(FirestoreLifecycle);
